import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/Layout"
import Hero from "../components/Hero"
import {
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  mainFeaturedPost: {
    position: "relative",
    // height:500,
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.common.white,
    // marginBottom: theme.spacing(4),
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  overlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: "rgba(0,0,0,.6)",
  },
  mainFeaturedPostContent: {
    position: "relative",
    padding: theme.spacing(3),
    // [theme.breakpoints.up("md")]: {
    //   padding: theme.spacing(6),
    //   paddingRight: 0,
    // },
  },
}))

export default function Template({ data }) {
  const { markdownRemark } = data
  const { frontmatter, html } = markdownRemark
  const post = frontmatter
  const classes = useStyles()
  const blogText = html.replace(/<[^>]+>/g, "").slice(0, 250)
  return (
    <Layout
      cssClass="blog-page"
      title={post.title + " | INVIZ AI Solutions"}
      description={blogText}
    >
      <Paper
        className={classes.mainFeaturedPost}
        style={{ backgroundImage: `url(${post.hero_image?.publicURL})` }}
      >
        {/* Increase the priority of the hero background image */}
        {
          <img
            style={{ display: "none" }}
            src={post.hero_image?.publicURL}
            // alt={post.imageText}
          />
        }
        <div className={classes.overlay} />
        <Grid>
          <Grid item>
            <div className={classes.mainFeaturedPostContent}>
              <Typography
                component="h3"
                variant="h4"
                color="inherit"
                gutterBottom
              >
                {post.title}
              </Typography>
              <Typography variant="caption" href="#">
                by {post.author}
              </Typography>
              <Typography style={{ fontSize: 14 }}>on {post.date}</Typography>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Container className="blog-html">
        <div className="blog-inner">
          <div dangerouslySetInnerHTML={{ __html: html }}></div>
          <br />
        </div>
      </Container>
    </Layout>
  )
  return (
    <div>
      <div></div>
    </div>
  )
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        hero_image {
          publicURL
        }
        author
        path
        title
      }
    }
  }
`
